import { mutate } from './api-consumer';

export default {
  async registerForPushNotifications(registrationData) {
    return mutate('registerForPushNotifications', registrationData);
  },
};
